<template>
    <CommonBox title="Upload File" @close="$emit('close')" @submit="$emit('close')">
       <el-upload
			class="upload-demo"
			ref="upload"
			:action="$http.http.defaults.baseURL + 'uploadFileProducts'"
			:headers="header"
			:data="data"
			:auto-upload="false"
			:multiple="true"
            :before-upload="beforeUpload"
			:file-list="fileList"
			:on-success="success"
		>
        <!-- 修改：把可选选项改为从数据库读取 -->
		<el-button style="margin-left:10px;" slot="trigger" size="small" type="primary">Select File</el-button>
         <br><br>
         <label style="margin-left:10px;display:inline-block;width:350px;color:red;">Pictures can only be uploaded in JPG and PNG formats.</label>
        <br><br>
                <label style="margin-left:10px;display:inline-block;width:150px;">Product Category：</label>
                <el-select style="width:160px;" v-model="data.ProductCategory"  @change="data.ProductModel=''" placeholder="">
                    <el-option
                        v-for="item in productCategoryList"
                        :key="item.ID"
                        :label="item.ProductCategory"
                        :value="item.ID">
                    </el-option>
                </el-select>
                <br><br>

                <label style="margin-left:10px;display:inline-block;width:150px;">Product Model：</label>
                <template>
                    <el-select style="width:160px;" v-model="data.ProductModel" placeholder="">
                        <el-option
                            v-for="item in productModelList"
                            :key="item.ID"
                            :label="item.ProductModel"
                            :value="item.ID">
                        </el-option>
                    </el-select>
                
                </template>
                <br><br>

                <label style="margin-left:10px;display:inline-block;width:150px;">Document Type：</label>
                <el-select style="width:160px;" v-model="data.DocumentType" placeholder="">
                    <el-option
                        v-for="item in documentTypeList"
                        :key="item.ID"
                        :label="item.DocumentType"
                        :value="item.ID">
                    </el-option>
                </el-select>
                <br><br>
        
		<el-button style="margin-left:10px;" size="small" type="success" @click="submitUpload">Upload to Server</el-button>
		</el-upload>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox1.vue";
// import { productCategoryList,productModel7List,documentTypeList } from "@/components/Products/data.js";
// import { unshiftAll } from "@/methods/selection.js";
export default {
    components:{
        CommonBox
    },
    props:{
    },
    data () {
        return {
            header:{},
            productCategoryList:"",
            productModelList:"",
            documentTypeList:"",
            data:{
                ProductCategory:"",
                ProductModel:"",
                DocumentType:""
            },
            fileList:[]
        };
    },
    mounted () {
        this.header = {
            "x-auth-token":localStorage.getItem('producttoken')
        };
        this.$http.get("getAllProductCategory",{},(data)=>{
            this.productCategoryList = data.data;
        });
        this.$http.get("getProductModel",{},(data)=>{
            this.productModelList = data.data;
        });
        this.$http.get("getAllDocumentType",{},(data)=>{
            this.documentTypeList = data.data;
        });
    },
    methods:{
        submitUpload () {
            this.$refs.upload.submit();
        },
        success (response) {
            if(response.code === 0) {
                this.$baseNotice.message(response.msg);
                this.$emit("success");
            }else{
                this.$baseNotice.message(response.msg,"error");
            }
        },
        //修改：多了图片格式的判断，只能上传jpg和PNG格式的图片
        beforeUpload (file) {
            if(file.size > 800 * 1024 * 1024) {
                this.$message.error("The size of "+file.name+" exceeds 800M !");
                return false;
            }else{
                //添加对photo类型文件的判断只能上传jpg类型和png类型
                let fileType=file.type;
                fileType=fileType.split("/")[0];
                if(fileType==="image") {
                    let fileName=file.name;
                    let documentType=fileName.split('.')[fileName.split('.').length-1];
                    if(documentType!=="jpg" && documentType!=="png") {
                        return false;
                    }
                }
            }

        }
    },
    watch:{
        'data.ProductCategory'() {
            this.$http.get("getAllProductModel",{CategoryID:this.data.ProductCategory},(data)=>{
                this.productModelList = data.data;
            });
            
        }
    }      
};
</script>
